/**
 * How a chart tells its series apart: a colour, a dash pattern and a marker
 * shape, all three, so no series is identified by hue alone.
 *
 * Colours are the `--color-chart-*` palette (see theme-base.css), never the
 * semantic colours: a series is an identity, and error red on "series four"
 * says something went wrong with a subject that is fine.
 *
 * Six colours, each with its own dash. Past six the colours come round again,
 * each time with the next marker shape, so the seventh series shares slot
 * one's colour and dash but not its marker — every combination is distinct up
 * to 24 series. A chart should never draw that many at once; the guarantee is
 * that a style follows its entity even when a filter shows series 3 and 9
 * together.
 */
export const CHART_SLOT_COUNT = 6;
/** Written out rather than built from the slot number, so every reference is findable. */
const COLORS = [
    'var(--color-chart-1)',
    'var(--color-chart-2)',
    'var(--color-chart-3)',
    'var(--color-chart-4)',
    'var(--color-chart-5)',
    'var(--color-chart-6)',
];
const DASHES = [undefined, '6 4', '2 4', '10 4', '6 4 2 4', '1 5'];
const SHAPES = ['circle', 'square', 'diamond', 'triangle'];
/** The style for the series at `index` among every series it could be shown with. */
export function chartSeriesStyle(index) {
    const slot = ((index % CHART_SLOT_COUNT) + CHART_SLOT_COUNT) % CHART_SLOT_COUNT;
    const round = Math.floor(Math.max(0, index) / CHART_SLOT_COUNT);
    return {
        color: COLORS[slot],
        dash: DASHES[slot],
        shape: SHAPES[(slot + round) % SHAPES.length],
    };
}
//# sourceMappingURL=chart-series.js.map